import { render } from "./QcDetails.vue?vue&type=template&id=14bd09c4&scoped=true"
import script from "./QcDetails.vue?vue&type=script&lang=js"
export * from "./QcDetails.vue?vue&type=script&lang=js"

import "./QcDetails.vue?vue&type=style&index=0&id=14bd09c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bd09c4"]])

export default __exports__